// A Jira Cloud site's address. P0 fetches the site's `tenant_info` from it,
// so only Atlassian's own domain is taken, with no path, port or user.
const SITE_URL_PATTERN =
  /^https:\/\/([a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)\.atlassian\.net\/?$/;

export const INVALID_SITE_URL =
  "Enter the site's address as https://<your-site>.atlassian.net, with no path.";

/** The site's name, `acme` in `https://acme.atlassian.net`, or `undefined`
 * when `url`, ignoring surrounding whitespace and case, isn't a Jira Cloud
 * site's address. */
export const toSiteName = (url: unknown): string | undefined => {
  if (typeof url !== "string") return undefined;
  const [, name] = SITE_URL_PATTERN.exec(url.trim().toLowerCase()) ?? [];
  return name;
};

/** Whether `url` is a Jira Cloud site's address. */
export const isSiteUrl = (url: unknown): url is string =>
  toSiteName(url) !== undefined;

/** The URL of the site's `tenant_info`, built from its validated name so no
 * part of what was typed reaches the fetch. */
export const toTenantInfoUrl = (siteName: string) =>
  `https://${siteName}.atlassian.net/_edge/tenant_info`;
